module.exports = __webpack_public_path__ + "img/1-1_05.96482a9d.jpg";